import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import App from './App';
import './styles/index.css';

/**
 * Dev-only: make a missing .catch loud during integration, so the Mayor
 * catches it before Phase 3 verification rather than seeing it as a mystery
 * console error in the smoke test. console.warn, not error, on purpose.
 */
if (import.meta.env.DEV) {
  window.addEventListener('unhandledrejection', (e) => {
    console.warn('[unhandled rejection — a panel is missing a .catch]', e.reason);
  });
}

const container = document.getElementById('root');
if (container === null) throw new Error('#root not found in index.html');

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary
      fallback={
        <div className="grid h-screen place-items-center bg-surface p-8 text-center text-ink">
          <div className="max-w-sm">
            <p className="text-lg font-semibold">my-hub could not start.</p>
            <p className="mt-2 text-sm text-ink-muted">
              Something failed outside any single panel. Reload the page; if it persists, check
              the browser console.
            </p>
          </div>
        </div>
      }
    >
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
